import { toObject } from "../../core/utils";
import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import identity from "lodash/fp/identity";
import flow from "lodash/fp/flow";
import isNil from "lodash/fp/isNil";
import constants from "../../core/constants";
import moment from "moment";

const formatPrice = (item) => item * constants.currencyBy;

class CommuterPackagePageTransform {
  constructor($injector) {
    "ngInject";

    this.justifyOptions = this.justifyOptions.bind(this);

    this.Lists = $injector.get("Lists");
    this.optionTypes = this.Lists.all.packageDiscountTypes;

    this.addOptions = {
      title: "Add new option",
      icon: "add",
      fields: [
        {
          title: "Name",
          name: "name_i18n",
          type: "text",
          isI18nText: true,
          isRequired: true,
        },
        {
          title: "Description",
          name: "description_i18n",
          type: "text",
          isI18nText: true,
          isRequired: true,
        },
        {
          title: "Option Price",
          name: "subscription_price_amount",
          type: "number",
          isText: true,
          isRequired: true,
          formatter: formatPrice,
        },
        {
          title: "Discount Type",
          name: "option_type",
          list: "packageDiscountTypes",
          isRequired: true,
        },
        {
          title: "Flat Fee Value",
          name: "flat_fee_value",
          type: "number",
          isText: true,
          isRequired: true,
          formatter: formatPrice,
          renderIf: '{{option_type}}.value === "flat_fee"',
        },
        {
          title: "Percentage Discount Value",
          name: "percentage_value",
          type: "number",
          isText: true,
          isRequired: true,
          renderIf: '{{option_type}}.value === "percentage"',
        },
        {
          title: "Maximum Discount Amount",
          name: "percentage_max_discount_value",
          type: "number",
          isText: true,
          isRequired: true,
          formatter: formatPrice,
          renderIf: '{{option_type}}.value === "percentage"',
        },
        {
          title: "Maximum Number of Trips",
          name: "booking_count",
          type: "number",
          isText: true,
          isRequired: true,
        },
        {
          title: "Max Bookings Per Day",
          name: "max_booking_per_day",
          type: "number",
          isText: true,
          isRequired: true,
        },
        {
          title: "Number of Days Validity",
          name: "subscription_period_amount",
          type: "number",
          isText: true,
          isRequired: true,
        },
        { title: "Active", name: "is_active", isCheckBox: true },
        { title: "Highlighted", name: "is_highlighted", isCheckBox: true },
      ],
    };

    // Users Listing
    this.customersFields = [
      { title: "Name", name: "name" },
      { title: "Subscription State", name: "subscription_state" },
    ];

    this.customersFilters = [
      {
        title: "User ID",
        name: "user_id",
        icon: "supervisor_account",
        resource: "Packages",
        resourceMethod: "getUsers",
      },
    ];
  }

  justify(data) {
    const format = (item) => {
      item.expiration_date = moment(item.expiration_date).format(
        constants.dateFormat
      );
      item.start_date = moment(item.start_date).format(constants.dateFormat);
      item.package_options = item.package_options.map(this.justifyOptions);

      return item;
    };

    return toObject(flow([format, identity])(data));
  }

  justifyOptions(option) {
    option.subscription_price_amount /= constants.currencyBy;
    option.percentage_max_discount_value = isNil(
      option.percentage_max_discount_value
    )
      ? null
      : option.percentage_max_discount_value / constants.currencyBy +
        " " +
        option.subscription_price_currency;
    option.percentage_value = isNil(option.percentage_value)
      ? null
      : option.percentage_value + " %";
    option.flat_fee_value = isNil(option.flat_fee_value)
      ? null
      : option.flat_fee_value / constants.currencyBy +
        " " +
        option.subscription_price_currency;

    return flow([toObject, identity])(option);
  }

  justifyUsers(data) {
    const statusValues = {
      subscribed: "Subscribed",
      unsubscribed: "Unsubscribed",
      cancelled: "Canceled",
      pending: "Pending",
      expired: "Expired",
    };
    const getSource = (item) => assign({ _id: item._id }, item._source);
    const format = (item) => {
      item.subscription_state =
        statusValues[item.subscription_state] || "Unsubscribed";

      return item;
    };

    return map(flow([getSource, format]))(data);
  }
}

export default CommuterPackagePageTransform;



// WEBPACK FOOTER //
// ./src/pages/commuterPackage/commuterPackage.transforms.js